export default __webpack_public_path__ + "media/images/services-07-370x250-c30df2f4fc53f2ccd3cdc0bed6fc95c6.jpg";